module.exports = __webpack_public_path__ + "static/media/5.b04075d8.jpg";